export default __webpack_public_path__ + "static/media/linkedin.77a390f7.svg";